<template>
  <section class="section bg-light2">
    <div class="container container-small row">
      <div class="col">
        <Blockquote
          v-if="quote && quote.text"
          :visible="visible || isMobile"
          :quote="quote" />
      </div>
      <div class="col" v-if="description && description.text">
        <transition name="text">
          <div class="section-text" v-if="visible || isMobile">
            <TextSection
              :description="description.text"
              :underline="false"
              :uppercase="false"
              :cutLength="360"
              :cutLengthTextBig="240" />
            <div class="section-link" v-if="description.title && link">
              <router-link :to="link" class="btn btn-simple">
                {{ description.title }}
              </router-link>
            </div>
          </div>
        </transition>
      </div>
      <ScrollTo v-if="scrollTop" :dark="true" :top="true" :where="0" speed="2500"/>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import Blockquote from '@/components/Blockquote.vue'
import ScrollTo from '@/components/ScrollTo.vue'
import TextSection from '@/components/TextSection.vue'

export default {
  name: 'OverflowBlockquoteSection',
  props: ['description', 'quote', 'link', 'visible', 'scrollTop'],
  components: {
    Blockquote,
    ScrollTo,
    TextSection
  },
  computed: {
    ...mapGetters([
      'breakpoint'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  }
}
</script>

<style scoped lang="scss">
  .section {
    .container {
      padding: $gap-xl 0 ($gap-xl * 2);
      min-height: 28em;
    } // END .container;

    /deep/ blockquote {
      margin: 0;
    }

    &-text {
      width: 100%;

      /deep/ .parts-wrapper {
        width: 100%;
        max-width: 370px;
        height: 250px;

        @include screen ('sm') {
          margin-top: 0;
        }
      }

      @include tablet {
        width: 100%;
        max-width: 100%;

        /deep/ h2 {
          max-width: 100%;
        }
      } // END @include tablet;
      @include mobile {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 280px;
            max-height: 280px;
          }
        }
      }
      @include mobile-small {
        /deep/ .multi {
          .parts-wrapper {
            min-height: 360px;
            max-height: 360px;
          }
        }
      }
      .font-size-l & {
        @include mobile {
          /deep/ .multi {
            .parts-wrapper {
              min-height: 200px;
            }
          }
        }
        @include mobile-small {
          /deep/ .multi {
            .parts-wrapper {
              min-height: 300px;
            }
          }
        }
      }
    } // END .section-text;

    &-link {
      text-align: right;

      @include screen ('sm') {
        text-align: left;
      }
    } // END .section-link;

  } // END .section

</style>
